/** 代理方法 method 字段 */
export enum ProxyMethod {
  /** 不使用代理 */
  none = 0,
  /** IE代理 */
  ie = 1,
  /** http代理或者sock5代理（自定义代理） */
  custom = 2
}

/** 代理模式 mode 字段（当 method=custom 时使用） */
export enum ProxyMode {
  /** HTTP代理 */
  http = 1,
  /** SOCK5代理 */
  socks5 = 5
}

/** 代理类型（UI展示用，值 = method + mode * 0.1） */
export enum ProxyMethodShow {
  none = 0,
  ie = 1,
  http = 2.1,
  socks5 = 2.5
}

/** UI展示值 → 接口字段的映射 */
const PROXY_CONFIG_MAP: Record<ProxyMethodShow, { method: ProxyMethod; mode: number }> = {
  [ProxyMethodShow.none]: { method: ProxyMethod.none, mode: 0 },
  [ProxyMethodShow.ie]: { method: ProxyMethod.ie, mode: 0 },
  [ProxyMethodShow.http]: { method: ProxyMethod.custom, mode: ProxyMode.http },
  [ProxyMethodShow.socks5]: { method: ProxyMethod.custom, mode: ProxyMode.socks5 }
}

/** 根据 method + mode 获取 UI 展示值 */
export function getProxyShowValue(method: number, mode: number): ProxyMethodShow {
  return (method + mode * 0.1) as ProxyMethodShow
}

/** 根据 UI 展示值获取接口字段 */
export function getProxyConfig(showValue: ProxyMethodShow) {
  return PROXY_CONFIG_MAP[showValue]
}
